module.exports = __webpack_public_path__ + "static/media/home.82fd3eed.svg";